import { fade, makeStyles } from '@material-ui/core'

interface SpinnerProps {
  horizontal: boolean;
  color: string;
  textColor: string;
  textSize: string | number;
}

const useStyles = makeStyles(() => ({
  root: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: (props: SpinnerProps) => props.horizontal ? 'row' : 'column',
    justifyContent: props => props.horizontal ? 'flex-start' : 'center',
    position: 'relative',
    textAlign: 'center',
  },
  bottom: {
    color: props => fade(props.color, 0.16),
    marginRight: props => props.horizontal ? 10 : 0,
  },
  top: {
    animationDuration: '1000ms',
    color: props => props.color,
    marginRight: props => props.horizontal ? 10 : 0,
    position: 'absolute',
    top: 0,
  },
  circle: {
    strokeLinecap: 'round'
  },
  text: {
    color: props => props.textColor,
    fontSize: props => props.textSize
  }
}))

export default useStyles
